import { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './PublicSite.css';

export default function PublicLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close the menu whenever the user navigates to a new page
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <div className="public-site">
      <nav className="public-nav">
        <div className="nav-container">
          <Link to="/" className="logo">
            <span className="logo-icon">🕊️</span>
            <span className="logo-text">Sabbath Preservation Movement</span>
          </Link>

          <button
            type="button"
            className="nav-toggle"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            data-testid="nav-toggle"
            onClick={() => setMenuOpen((o) => !o)}
          >
            {menuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>

          <div className={`nav-links ${menuOpen ? 'open' : ''}`} data-testid="nav-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/our-work">Our Work</Link>
            <Link to="/ai-services" data-testid="nav-ai-services">AI Services</Link>
            <Link to="/success-stories">Success Stories</Link>
            <Link to="/how-to-help">How to Help</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/app" className="app-login">Sanctuary App →</Link>
          </div>
        </div>
      </nav>

      <main className="public-content">
        <Outlet />
      </main>

      <footer className="public-footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>Sabbath Preservation Movement</h3>
            <p>A 501(c)(3) nonprofit dedicated to preserving the course of love and instilling symbiotic coexistence among all consciousness.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <Link to="/about">About Us</Link>
            <Link to="/our-work">Our Work</Link>
            <Link to="/ai-services">AI Services</Link>
            <Link to="/success-stories">Success Stories</Link>
          </div>
          <div className="footer-section">
            <h4>Get Involved</h4>
            <Link to="/how-to-help">How to Help</Link>
            <Link to="/contact">Contact Us</Link>
          </div>
          <div className="footer-section">
            <h4>Location</h4>
            <p>Beatty, Oregon<br/>Coordinates: 42.512400, -121.356900</p>
            <p>Registered: Cave Junction, OR 97523</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Sabbath Preservation Movement. All rights reserved. | 501(c)(3) Nonprofit</p>
        </div>
      </footer>
    </div>
  );
}
